import { Routes, Route } from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'

import Layout from 'layout'
import Home from 'pages/home'
import OTPPage from 'pages/otp/PhoneNo'
import VerifyOTPPage from 'pages/otp/VerifyOtp'
import PinPage from 'pages/pin'
import HealthPage from 'pages/health'
import OtpLogin from 'pages/otp/OtpLogin'
import TurnstileVerify from 'pages/turnstileVerify'

const App = (props) => {
  return (
    <ChakraProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/health" element={<HealthPage />} />
          <Route path="/pin" element={<PinPage />} />
          <Route path="/otp" element={<OtpLogin />} />
          <Route path="/otp/verify" element={<VerifyOTPPage />} />
          <Route path="/turnstile/verify" element={<TurnstileVerify />} />

          <Route path="/provider-web" element={<Home />} />
          <Route path="/provider-web/health" element={<HealthPage />} />
          <Route path="/provider-web/pin" element={<PinPage />} />
          <Route path="/provider-web/otp" element={<OTPPage />} />
          <Route path="/provider-web/otp/verify" element={<VerifyOTPPage />} />
        </Routes>
      </Layout>
    </ChakraProvider>
  )
}

export default App
